import { memo } from 'react';
import { cn, List, RawHtml } from '@divlab/divanui';

import styles from './OrderedList.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface OrderedListProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  list: string[];
  cnItem?: string;
}

const OrderedList: FC<OrderedListProps> = (props) => {
  const { className, list, cnItem, ...restProps } = props;

  return (
    <List
      {...restProps}
      className={cn(styles.list, className)}
      items={list}
      renderChild={(item: string) => (
        <div className={cn(styles.item, cnItem)}>
          <div className={styles.itemContainer}>
            <RawHtml html={item} />
          </div>
        </div>
      )}
    />
  );
};

export default memo(OrderedList);
